import QuadrantLevel from './QuadrantLevel';
import ParameterErrors from '../../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const QUADRANT_LEVELS_JSON_KEY='l';
export default class QuadrantsForCameraAngle{
	constructor({quadrantLevels }){
		this._quadrantLevels = quadrantLevels; 
	}
	get quadrantLevels(){
		return this._quadrantLevels;
	}
	getObjectIds({proportionX, proportionY, proportionZ}){
		let allObjectIds = [];
		for(var quadrantLevelIndex=0; quadrantLevelIndex<this._quadrantLevels.length; quadrantLevelIndex++){
			const quadrantLevel = this._quadrantLevels[quadrantLevelIndex];
			const objectIds = quadrantLevel.getObjectIds({proportionX, proportionY, proportionZ});
			if(objectIds===null||objectIds.length<1)continue;
			allObjectIds=allObjectIds.concat(objectIds);
		}
		return allObjectIds;
	}
	static fromJSON(jObject){
		const quadrantLevels = 
			jObject[QUADRANT_LEVELS_JSON_KEY]
			.map(quadrantLevelJObject=>
				QuadrantLevel.fromJSON(quadrantLevelJObject));
		return new QuadrantsForCameraAngle({quadrantLevels});
	}
}